import { css } from 'twin.macro'
import type { TBackgroundPattern } from './interface'

const BackgroundPattern = (props: TBackgroundPattern) => {
  const { url, width, height, clips, ...rest } = props
  return (
    <div
      tw="absolute left-[50%] translate-x-[-50%] translate-y-[-50%] z-[-1] flex flex-col mb-12"
      css={[{ width, height }]}
      {...rest}
    >
      <div
        css={[
          {
            backgroundImage: `url("${url}")`,
          },
          clips &&
            Object.entries(clips).map(
              ([media, clip]) => css`
                & {
                  @media screen and (min-width: ${media}) {
                    clip-path: polygon(0 0, 100% 0, 100% ${clip}, 0 ${clip});
                  }
                }
              `,
            ),
        ]}
        tw="bg-cover bg-no-repeat w-full h-full"
      />
    </div>
  )
}

export default BackgroundPattern
